// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_RWS = require("../Control.Monad.RWS/index.js");
var Control_Monad_RWS_Trans = require("../Control.Monad.RWS.Trans/index.js");
var Control_Monad_Reader_Class = require("../Control.Monad.Reader.Class/index.js");
var Control_Monad_Writer_Class = require("../Control.Monad.Writer.Class/index.js");
var Data_Identity = require("../Data.Identity/index.js");
var Data_Lens_Getter = require("../Data.Lens.Getter/index.js");
var Data_Lens_Internal_Forget = require("../Data.Lens.Internal.Forget/index.js");
var Data_Lens_Iso = require("../Data.Lens.Iso/index.js");
var Data_Lens_Record = require("../Data.Lens.Record/index.js");
var Data_Lens_Setter = require("../Data.Lens.Setter/index.js");
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Profunctor_Strong = require("../Data.Profunctor.Strong/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Lunarbox_Data_Dataflow_Class_Substituable = require("../Lunarbox.Data.Dataflow.Class.Substituable/index.js");
var Lunarbox_Data_Dataflow_Constraint = require("../Lunarbox.Data.Dataflow.Constraint/index.js");
var Lunarbox_Data_Lens = require("../Lunarbox.Data.Lens/index.js");
var InferState = function (x) {
    return x;
};
var InferOutput = function (x) {
    return x;
};
var InferEnv = function (x) {
    return x;
};
var Infer = function (x) {
    return x;
};
var semigruopInferState = new Data_Semigroup.Semigroup(function (v) {
    return function (v1) {
        return {
            count: v.count + v1.count | 0
        };
    };
});
var semigroupInferOutput = function (dictOrd) {
    return Data_Semigroup.semigroupRecord()(Data_Semigroup.semigroupRecordCons(new Data_Symbol.IsSymbol(function () {
        return "constraints";
    }))()(Data_Semigroup.semigroupRecordCons(new Data_Symbol.IsSymbol(function () {
        return "errors";
    }))()(Data_Semigroup.semigroupRecordCons(new Data_Symbol.IsSymbol(function () {
        return "typeMap";
    }))()(Data_Semigroup.semigroupRecordNil)(Data_Map_Internal.semigroupMap(dictOrd)))(Data_Semigroup.semigroupArray))(Lunarbox_Data_Dataflow_Constraint.semigroupConstraintSet));
};
var newtypeInferState = new Data_Newtype.Newtype(function (n) {
    return n;
}, InferState);
var newtypeInferOutput = new Data_Newtype.Newtype(function (n) {
    return n;
}, InferOutput);
var newtypeInferEnv = new Data_Newtype.Newtype(function (n) {
    return n;
}, InferEnv);
var monoidInferState = new Data_Monoid.Monoid(function () {
    return semigruopInferState;
}, {
    count: 0
});
var runInfer = function (env) {
    return function (v) {
        return Control_Monad_RWS.evalRWS(v)(env)(Data_Monoid.mempty(monoidInferState));
    };
};
var monoidInferOutput = function (dictOrd) {
    return Data_Monoid.monoidRecord()(Data_Monoid.monoidRecordCons(new Data_Symbol.IsSymbol(function () {
        return "constraints";
    }))(Lunarbox_Data_Dataflow_Constraint.monoidConstraintSet)()(Data_Monoid.monoidRecordCons(new Data_Symbol.IsSymbol(function () {
        return "errors";
    }))(Data_Monoid.monoidArray)()(Data_Monoid.monoidRecordCons(new Data_Symbol.IsSymbol(function () {
        return "typeMap";
    }))(Data_Map_Internal.monoidMap(dictOrd))()(Data_Monoid.monoidRecordNil))));
};
var monadWriterInfer = function (dictOrd) {
    return Control_Monad_RWS_Trans.monadWriterRWST(Data_Identity.monadIdentity)(monoidInferOutput(dictOrd));
};
var monadTellInfer = function (dictOrd) {
    return Control_Monad_RWS_Trans.monadTellRWST(Data_Identity.monadIdentity)(monoidInferOutput(dictOrd));
};
var monadStateInfer = function (dictOrd) {
    return Control_Monad_RWS_Trans.monadStateRWST(Data_Identity.monadIdentity)(monoidInferOutput(dictOrd));
};
var monadReaderInfer = function (dictOrd) {
    return Control_Monad_RWS_Trans.monadReaderRWST(Data_Identity.monadIdentity)(monoidInferOutput(dictOrd));
};
var monadInfer = function (dictOrd) {
    return Control_Monad_RWS_Trans.monadRWST(Data_Identity.monadIdentity)(monoidInferOutput(dictOrd));
};
var monadAskInfer = function (dictOrd) {
    return Control_Monad_RWS_Trans.monadAskRWST(Data_Identity.monadIdentity)(monoidInferOutput(dictOrd));
};
var functorInfer = Control_Monad_RWS_Trans.functorRWST(Data_Identity.functorIdentity);
var bindInfer = function (dictOrd) {
    return Control_Monad_RWS_Trans.bindRWST(Data_Identity.bindIdentity)(monoidInferOutput(dictOrd));
};
var applyInfer = function (dictOrd) {
    return Control_Monad_RWS_Trans.applyRWST(Data_Identity.bindIdentity)(monoidInferOutput(dictOrd));
};
var applicativeInfer = function (dictOrd) {
    return Control_Monad_RWS_Trans.applicativeRWST(Data_Identity.monadIdentity)(monoidInferOutput(dictOrd));
};
var _typeMap = function (dictStrong) {
    var $41 = Lunarbox_Data_Lens.newtypeIso(newtypeInferOutput)(dictStrong);
    var $42 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "typeMap";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
    return function ($43) {
        return $41($42($43));
    };
};
var _typeEnv = function (dictStrong) {
    var $44 = Data_Lens_Iso.iso(Data_Newtype.unwrap(newtypeInferEnv))(Data_Newtype.wrap(newtypeInferEnv))(dictStrong.Profunctor0());
    var $45 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "typeEnv";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
    return function ($46) {
        return $44($45($46));
    };
};
var substituableInferEnv = new Lunarbox_Data_Dataflow_Class_Substituable.Substituable((function () {
    var $47 = Data_Lens_Setter.over(_typeEnv(Data_Profunctor_Strong.strongFn));
    var $48 = Lunarbox_Data_Dataflow_Class_Substituable.apply(Lunarbox_Data_Dataflow_Class_Substituable.envSusbt);
    return function ($49) {
        return $47($48($49));
    };
})(), function (v) {
    return Lunarbox_Data_Dataflow_Class_Substituable.ftv(Lunarbox_Data_Dataflow_Class_Substituable.envSusbt)(v.typeEnv);
});
var _location = function (dictStrong) {
    var $50 = Data_Lens_Iso.iso(Data_Newtype.unwrap(newtypeInferEnv))(Data_Newtype.wrap(newtypeInferEnv))(dictStrong.Profunctor0());
    var $51 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "location";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
    return function ($52) {
        return $50($51($52));
    };
};
var createConstraint = function (dictOrd) {
    return function (typeLeft) {
        return function (typeRight) {
            return Control_Bind.bind(bindInfer(dictOrd))(Control_Monad_Reader_Class.asks(monadAskInfer(dictOrd))(Data_Lens_Getter.view(_location(Data_Lens_Internal_Forget.strongForget))))(function (source) {
                return Control_Monad_Writer_Class.tell(monadTellInfer(dictOrd))({
                    constraints: Lunarbox_Data_Dataflow_Constraint.ConstraintSet(Control_Applicative.pure(Data_List_Types.applicativeList)({
                        source: source,
                        typeRight: typeRight,
                        typeLeft: typeLeft
                    })),
                    typeMap: Data_Monoid.mempty(Data_Map_Internal.monoidMap(dictOrd)),
                    errors: [  ]
                });
            });
        };
    };
};
var createError = function (dictOrd) {
    return function (getError) {
        return Control_Bind.bind(bindInfer(dictOrd))(Control_Monad_Reader_Class.asks(monadAskInfer(dictOrd))(Data_Lens_Getter.view(_location(Data_Lens_Internal_Forget.strongForget))))(function (location) {
            return Control_Monad_Writer_Class.tell(monadTellInfer(dictOrd))({
                errors: [ getError(location) ],
                typeMap: Data_Monoid.mempty(Data_Map_Internal.monoidMap(dictOrd)),
                constraints: Data_Monoid.mempty(Lunarbox_Data_Dataflow_Constraint.monoidConstraintSet)
            });
        });
    };
};
var rememberType = function (dictOrd) {
    return function (type$prime) {
        return Control_Bind.bind(bindInfer(dictOrd))(Control_Monad_Reader_Class.asks(monadAskInfer(dictOrd))(Data_Lens_Getter.view(_location(Data_Lens_Internal_Forget.strongForget))))(function (location) {
            return Control_Bind.discard(Control_Bind.discardUnit)(bindInfer(dictOrd))(Control_Monad_Writer_Class.tell(monadTellInfer(dictOrd))({
                constraints: Data_Monoid.mempty(Lunarbox_Data_Dataflow_Constraint.monoidConstraintSet),
                typeMap: Data_Map_Internal.singleton(location)(type$prime),
                errors: [  ]
            }))(function () {
                return Control_Applicative.pure(applicativeInfer(dictOrd))(type$prime);
            });
        });
    };
};
var withLocation = function (dictOrd) {
    var $53 = Control_Monad_Reader_Class.local(monadReaderInfer(dictOrd));
    var $54 = Data_Lens_Setter.set(_location(Data_Profunctor_Strong.strongFn));
    return function ($55) {
        return $53($54($55));
    };
};
var _count = function (dictStrong) {
    var $56 = Data_Lens_Iso.iso(Data_Newtype.unwrap(newtypeInferState))(Data_Newtype.wrap(newtypeInferState))(dictStrong.Profunctor0());
    var $57 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "count";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
    return function ($58) {
        return $56($57($58));
    };
};
var _constraints = function (dictStrong) {
    var $59 = Lunarbox_Data_Lens.newtypeIso(newtypeInferOutput)(dictStrong);
    var $60 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "constraints";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
    return function ($61) {
        return $59($60($61));
    };
};
module.exports = {
    InferState: InferState,
    InferOutput: InferOutput,
    InferEnv: InferEnv,
    Infer: Infer,
    "_count": _count,
    "_location": _location,
    "_typeEnv": _typeEnv,
    "_constraints": _constraints,
    "_typeMap": _typeMap,
    runInfer: runInfer,
    withLocation: withLocation,
    createConstraint: createConstraint,
    rememberType: rememberType,
    createError: createError,
    newtypeInferOutput: newtypeInferOutput,
    semigroupInferOutput: semigroupInferOutput,
    monoidInferOutput: monoidInferOutput,
    newtypeInferState: newtypeInferState,
    semigruopInferState: semigruopInferState,
    monoidInferState: monoidInferState,
    newtypeInferEnv: newtypeInferEnv,
    substituableInferEnv: substituableInferEnv,
    functorInfer: functorInfer,
    applyInfer: applyInfer,
    applicativeInfer: applicativeInfer,
    bindInfer: bindInfer,
    monadInfer: monadInfer,
    monadAskInfer: monadAskInfer,
    monadReaderInfer: monadReaderInfer,
    monadTellInfer: monadTellInfer,
    monadWriterInfer: monadWriterInfer,
    monadStateInfer: monadStateInfer
};
